import Vue from "vue";
import VueI18n from "vue-i18n";
import en from "./en.json";
import ar from "./ar.json";
import zh from "./zh.json";
import hi from "./hi.json";
import tr from "./tr.json";
import th from "./th.json";
import vi from "./vi.json";
import ms from "./ms.json";
import id from "./id.json";
import ur from "./ur.json";
import tl from "./tl.json";
import pt from "./pt.json";
import es from "./es.json";
import zh_TW from "./zh_TW.json";
import pa from "./pa.json"
import ta from "./ta.json"
import te from "./te.json"
import locale from "@mono/ui/locale";
import _ from "lodash";
import { getLanguageCode } from "@mono/bridge";

Vue.use(VueI18n);

const messages = { en, ar, zh, zh_TW, hi, tr, th, vi, ms, id, ur, tl, pt, es, pa, ta, te };

export const createI18n = async () => {
  const langCode = await getLanguageCode();
  return new VueI18n({
    locale: langCode,
    fallbackLocale: "en",
    messages: _.merge(locale, messages),
  });
};
